import CryptoJS from "crypto-js";
import { CRYPTO_SECRET_KEY } from "src/_config";

const secretKey = CRYPTO_SECRET_KEY.toString();

export const encryptText = (text: string): string => {
  const ciphertext = CryptoJS.AES.encrypt(text, secretKey)
    .toString()
    .replace(/\+/g, "xMl3Jk")
    .replace(/\//g, "Por21Ld")
    .replace(/=/g, "Ml32");
  return ciphertext;
};

export const decryptText = (ciphertext: string): string => {
  const bytes = CryptoJS.AES.decrypt(
    ciphertext
      .toString()
      .replace(/xMl3Jk/g, "+")
      .replace(/Por21Ld/g, "/")
      .replace(/Ml32/g, "="),
    secretKey
  );
  const originalText = bytes.toString(CryptoJS.enc.Utf8);
  return originalText;
};
